import { FlagDetailPage } from '@features/feature-flags';
import { Navigate, useParams } from 'react-router';

/**
 * Thin route file: pull the flag key off the URL, hand it to the feature.
 *
 * Worth noting what this route costs now, because it was the sharpest argument
 * against the alternative static path: under `next build --output export` every
 * dynamic segment must be enumerated at build time via `generateStaticParams`,
 * and flag keys live in DynamoDB — unknowable when the bundle is built. A client
 * router has no such constraint. `/flags/events.online_checkout` is just a
 * string match at runtime.
 */
export function FlagDetailRoute() {
    const { key } = useParams<{ key: string }>();

    if (!key) return <Navigate to="/catalog/flags" replace />;

    return <FlagDetailPage flagKey={key} />;
}
